(function () {
  "use strict";

  var e = {
    d: function d(o, r) {
      for (var t in r) {
        e.o(r, t) && !e.o(o, t) && Object.defineProperty(o, t, {
          enumerable: !0,
          get: r[t]
        });
      }
    },
    o: function o(e, _o) {
      return Object.prototype.hasOwnProperty.call(e, _o);
    },
    r: function r(e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }
  },
      o = {};
  e.r(o), e.d(o, {
    default: function _default() {
      return r;
    }
  });
  var r = "precision mediump float;\n\nvarying vec4 v_color;\n\nvoid main(void) {\n  gl_FragColor = v_color;\n}\n";
  module.exports = o;
})();